import React from "react";

const Stats = () => {
  return <div className="modal-down">Stats</div>;
};

export default Stats;
